// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

import checkAccess from 'utils/roles/checkAccess';

const getFranchiseRegion = () => {
  const JWT = localStorage.getItem('accessToken');

  if (JWT) {
    const decode = jwt_decode(JWT);

    if (checkAccess([2])) {
      return decode?.region;
    }

    return decode?.role;
  }
  return null;
};

export default getFranchiseRegion;
